module.exports = __webpack_public_path__ + "static/img/11.e5afa35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/sp/11.png
// module id = yxLM
// module chunks = 0